import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import CloseIcon from '@wix/da-ds/pkg/Icons/24x24/Close';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ButtonB5 from '../../../Button/ButtonB5';
import { getDeviationResourceType } from '../../_helpers';
import { BiData } from '@wix/da-bi/pkg/events';
const ThumbRemove = ({ deviation, className, biData, onRemove })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(ButtonB5, {
        icon: CloseIcon,
        iconProps: {
            size: IconSize.MEDIUM
        },
        withBackground: true,
        biData: BiData(_object_spread_props(_object_spread({}, biData), {
            evid: 405,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        })),
        onClick: onRemove
    }));
};
ThumbRemove.displayName = 'ThumbRemove';
export default ThumbRemove;
